import {
    BookOpen, ExternalLink, Link
} from 'lucide-react';
import {
    useContext
} from 'react';
import {
    SidebarContext
} from '../knowledgeBuilderContext/KBSidebarContext';
import {
    cn
} from 'shared/lib/utils';
const ICON_SIZE = 15;

function QueryAttribute({
    icon, label, value, type
}) {
    return (
        <>
            <div className="flex text-black items-center whitespace-nowrap gap-1 text-xs">
                {icon}
                {label}: {type === 'link' ?
                    <a className="underline items-center flex gap-1" href={value} target="_blank" rel="noopener noreferrer">Open<ExternalLink size={ICON_SIZE - 2} /></a>
                    : value}
            </div>
        </>
    );
}

export default function QueryResult({
    fileName, result, selected, searchType
}) {

    const DISPLAYED_ATTRIBUTES = [
        {
            key: 'page_number',
            icon: <BookOpen size={ICON_SIZE} />,
            label: 'Page',
            type: 'number'
        },
        {
            key: 'presigned_url',
            icon: <Link size={ICON_SIZE} />,
            label: 'Link',
            type: 'link'
        }
    ];
    const {
        setSelectedQuery
    } = useContext(SidebarContext);
    const handleClick = () => {
        setSelectedQuery(result);
    };

    const showScore = !['hybrid', 'keyword'].includes(searchType?.value?.toLowerCase());

    return (
        <>
            <div onClick={() => handleClick()} className={cn('hover:cursor-pointer p-2 mb-2 last:mb-0 transition-all', selected ? 'bg-[#B92744] bg-opacity-10 rounded-xl' : 'hover:bg-neutral-100 rounded-xl')}>
                <div className="flex items-center text-neutral-700 font-bold justify-between">
                    <p>{fileName}</p>
                    <div className="flex item-center gap-2">
                        {result.score && showScore ? <p><span className="text-black flex items-center text-xs font-thin italic">Score:</span>{parseFloat(result.score * 100).toFixed(2)}%</p> : null}
                    </div>
                </div>
                <div className="flex flex-wrap gap-2 mt-4">
                    {DISPLAYED_ATTRIBUTES.map((attribute, i) => (
                        result[attribute.key] ? <QueryAttribute key={i} type={attribute.type} icon={attribute.icon} label={attribute.label} value={result[attribute.key]} /> : null
                    ))}
                </div>
            </div>
        </>
    );
}